import api from '../../plugins/api';

// api.get сам кладёт второй аргумент в params: { dealId } даёт ?dealId=13.
const getClientUploadStatus = ({ dealId }) => {
  return api.get('/api/crm/clientUpload/status', { dealId });
};

export default getClientUploadStatus;
